import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class FeeStructure extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from Fee Structure</h1>
      </div>
    );
  }
}

export default FeeStructure;